import React from "react";
import PropTypes from "prop-types";
import styles from "./SelectionSummary.module.scss";

const SelectionSummary = ({ selectedCount, showSelectionSummary}) => {
  const summaryText = showSelectionSummary
  ? `${selectedCount} item (s) selected`
  : selectedCount > 0
    ? `${selectedCount} item(s) selected`
    : null;

  return (
    <div className={styles.selectionSummary}>
      {summaryText}
    </div>
  );
};

SelectionSummary.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  showSelectionSummary: PropTypes.bool
};

export default SelectionSummary;
